const KNOWN_MEMBER_LEGAL_LOCALES: Record<string, string> = {
  ko: 'ko-KR',
  'ko-kr': 'ko-KR',
  en: 'en',
  'en-us': 'en',
  'en-gb': 'en',
  ja: 'ja-JP',
  'ja-jp': 'ja-JP',
  'zh-hant': 'zh-Hant',
  'zh-tw': 'zh-Hant',
  'zh-hant-tw': 'zh-Hant',
  de: 'de-DE',
  'de-de': 'de-DE',
  fr: 'fr-FR',
  'fr-fr': 'fr-FR',
  es: 'es-ES',
  'es-es': 'es-ES',
  it: 'it-IT',
  'it-it': 'it-IT',
}

/**
 * mioSegno UI locale을 2n4uMember v1.4.1 legal locale로 정규화합니다.
 * 알 수 없는 locale은 앱에서 영어로 바꾸지 않고 중앙 Member에 그대로 전달해
 * Member의 authoritative en -> ko-KR fallback 정책을 사용합니다.
 */
export function toMemberLegalLocale(uiLocale: string): string {
  const normalized = uiLocale.trim().replace(/_/g, '-')
  if (!normalized) return 'en'
  return KNOWN_MEMBER_LEGAL_LOCALES[normalized.toLowerCase()] ?? normalized
}

/** public Terms/Privacy URL에 현재 legal locale만 안전하게 덧붙이거나 교체합니다. */
export function legalDocumentUrl(baseUrl: string, uiLocale: string): string {
  const raw = baseUrl.trim()
  if (!raw) return raw
  const locale = toMemberLegalLocale(uiLocale)
  try {
    const absolute = /^[A-Za-z][A-Za-z0-9+.-]*:\/\//.test(raw)
    const url = new URL(raw, 'https://miosegno.invalid')
    url.searchParams.set('locale', locale)
    if (absolute) return url.toString()
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    const separator = raw.includes('?') ? '&' : '?'
    return `${raw}${separator}locale=${encodeURIComponent(locale)}`
  }
}
